import { render, staticRenderFns } from "./PtTabs.vue?vue&type=template&id=7da905a6&scoped=true"
import script from "./PtTabs.vue?vue&type=script&lang=js"
export * from "./PtTabs.vue?vue&type=script&lang=js"
import style0 from "./PtTabs.vue?vue&type=style&index=0&id=7da905a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da905a6",
  null
  
)

export default component.exports